/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tidy_Polite_Niklas_FoldInputs */

const fr_tidy_polite_niklas_fold = /** @type {(inputs: Tidy_Polite_Niklas_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher email, nom`)
};

/**

* @param {Tidy_Polite_Niklas_FoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tidy_polite_niklas_fold = /** @type {((inputs?: Tidy_Polite_Niklas_FoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tidy_Polite_Niklas_FoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tidy_polite_niklas_fold(inputs)
});